module.exports = __webpack_public_path__ + "static/media/insta.011405f5.svg";